var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 116,
    viewBox: "0 0 134 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.72474 22.24L0.0537109 29.7211L26.876 32.5147L27.853 29.8239C28.7099 27.4759 27.1331 24.9565 24.648 24.6908L1.72474 22.24ZM5.39245 29.2327C4.24415 29.7297 2.89876 29.1984 2.40173 28.0415C1.9047 26.8932 2.43602 25.5478 3.59289 25.0508C4.74977 24.5537 6.09517 25.085 6.5922 26.2334C7.08065 27.3902 6.54933 28.7356 5.39245 29.2327Z",
    fill: "url(#paint0_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.9616 29.4469L115.021 3.24153L114.961 1.25342L26.396 27.5787C26.1046 27.6644 25.8647 27.8872 25.7618 28.1786C25.4962 28.9327 26.1903 29.6697 26.9616 29.4469Z",
    fill: "url(#paint1_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.4119 43.8434C32.5147 44.0833 32.7803 44.2033 33.0289 44.1176L124.679 13.0363C124.953 12.942 125.09 12.6335 124.979 12.3678L124.962 12.3336C124.859 12.0936 124.593 11.9737 124.345 12.0593L32.7118 43.175C32.4376 43.2692 32.3005 43.5777 32.4119 43.8434Z",
    fill: "url(#paint2_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M40.3386 57.1776C40.4415 57.4175 40.7071 57.5375 40.9556 57.4518L128.407 23.3969C128.681 23.3026 128.818 22.9941 128.707 22.7284L128.69 22.6942C128.587 22.4542 128.321 22.3342 128.073 22.4199L40.6386 56.5177C40.3643 56.6034 40.2272 56.9119 40.3386 57.1776Z",
    fill: "url(#paint3_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M48.574 70.2461C48.6768 70.486 48.9425 70.606 49.191 70.5203L131.081 33.6803C131.355 33.586 131.492 33.2775 131.38 33.0119L131.363 32.9776C131.26 32.7377 130.995 32.6177 130.746 32.7034L48.8739 69.5863C48.5997 69.6805 48.4626 69.9804 48.574 70.2461Z",
    fill: "url(#paint4_linear_59_1663)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M58.377 76.0047L58.2913 76.039L58.2656 75.9705L58.377 76.0047Z",
    fill: "url(#paint5_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M25.5139 32.4206L51.4621 74.8907L51.3936 73.4425L26.0709 32.1807L25.4453 32.2578",
    fill: "url(#paint6_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M51.4191 74.0423V74.068C51.4105 74.0594 51.3933 74.0423 51.3848 74.0337L51.4191 74.0423Z",
    fill: "url(#paint7_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M58.0089 75.3708L58.1718 75.7564C55.8066 76.6047 53.5528 76.0906 51.4105 73.9482L51.3848 73.4426C51.5733 73.6826 51.7618 73.8968 51.9589 74.1025C53.5614 75.7649 55.3953 76.3048 57.4862 75.5764C57.6662 75.5164 57.829 75.4479 58.0089 75.3708Z",
    fill: "url(#paint8_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M58.1724 75.7562L58.4295 76.3475C55.6701 77.53 53.3821 76.9216 51.454 74.8821L51.4111 73.9395C53.5535 76.099 55.8158 76.6045 58.1724 75.7562Z",
    fill: "url(#paint9_radial_59_1663)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M26.2336 31.8208L51.3935 73.2711L51.3163 71.8229L26.7906 31.5808L26.165 31.6579L26.2336 31.8208Z",
    fill: "url(#paint10_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M51.3507 72.4229V72.4486C51.3421 72.44 51.325 72.4229 51.3164 72.4143L51.3507 72.4229Z",
    fill: "url(#paint11_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M57.9406 73.7509L58.1034 74.1365C55.7382 74.9849 53.4845 74.4707 51.3421 72.3283L51.3164 71.8228C51.5049 72.0541 51.6934 72.2769 51.8905 72.4826C53.493 74.1451 55.3269 74.6849 57.4178 73.9565C57.5892 73.8965 57.7606 73.828 57.9406 73.7509Z",
    fill: "url(#paint12_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M58.1031 74.1365L58.3602 74.7278C55.6008 75.9104 53.3128 75.302 51.3846 73.2625L51.3418 72.3198C53.4842 74.4708 55.7379 74.9849 58.1031 74.1365Z",
    fill: "url(#paint13_radial_59_1663)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M26.4387 30.7753L51.3158 71.643L51.2472 70.1947L26.9957 30.5354L26.3701 30.6125L26.4387 30.7753Z",
    fill: "url(#paint14_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M51.2814 70.7947V70.8204C51.2728 70.8118 51.2556 70.7947 51.2471 70.7861L51.2814 70.7947Z",
    fill: "url(#paint15_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M57.8625 72.1229L58.0253 72.5086C55.6601 73.357 53.4063 72.8428 51.264 70.7004L51.2383 70.1948C51.4268 70.4348 51.6153 70.649 51.8124 70.8547C53.4149 72.5171 55.2488 73.057 57.3397 72.3286C57.5197 72.2686 57.6911 72.2001 57.8625 72.1229Z",
    fill: "url(#paint16_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M58.0338 72.5086L58.2908 73.0999C55.5315 74.2825 53.2434 73.6741 51.3153 71.6345L51.2725 70.6919C53.4148 72.8428 55.6686 73.357 58.0338 72.5086Z",
    fill: "url(#paint17_radial_59_1663)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M27.1416 30.364L51.2474 70.0147L51.1789 68.5665L27.6986 30.124L27.0645 30.2011L27.1416 30.364Z",
    fill: "url(#paint18_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M51.2042 69.1665V69.1922C51.1956 69.1837 51.1785 69.1665 51.1699 69.158L51.2042 69.1665Z",
    fill: "url(#paint19_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M57.7941 70.4948L57.9569 70.8804C55.5918 71.7288 53.338 71.2146 51.1956 69.0722L51.1699 68.5667C51.3584 68.8066 51.547 69.0208 51.7441 69.2265C53.3466 70.889 55.1804 71.4288 57.2714 70.7004C57.4513 70.6405 57.6227 70.5719 57.7941 70.4948Z",
    fill: "url(#paint20_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M57.9663 70.8802L58.2234 71.4715C55.4641 72.6541 53.176 72.0456 51.2479 70.0061L51.2051 69.0635C53.3389 71.223 55.6012 71.7286 57.9663 70.8802Z",
    fill: "url(#paint21_radial_59_1663)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M120.179 0.662089L130.951 36.9537L129.923 35.9253L119.631 0.91061L120.111 0.499268",
    fill: "url(#paint22_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M130.352 36.3538L130.369 36.371C130.369 36.3538 130.369 36.3367 130.369 36.3281L130.352 36.3538Z",
    fill: "url(#paint23_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M126.89 42.121L127.061 42.5066C129.281 41.3326 130.429 39.3188 130.283 36.2938L129.923 35.9338C129.975 36.2338 130 36.5166 130.026 36.7993C130.172 39.1045 129.332 40.8184 127.387 41.881C127.232 41.9582 127.061 42.0353 126.89 42.121Z",
    fill: "url(#paint24_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M127.061 42.498L127.326 43.0893C130.06 41.8553 131.157 39.7472 130.943 36.9536L130.274 36.2852C130.428 39.3187 129.28 41.324 127.061 42.498Z",
    fill: "url(#paint25_radial_59_1663)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M119.255 0.790751L129.795 35.8055L128.775 34.7771L118.706 1.03926L119.186 0.62793L119.255 0.790751Z",
    fill: "url(#paint26_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M129.195 35.2054L129.212 35.2225C129.212 35.2054 129.212 35.1883 129.212 35.1797L129.195 35.2054Z",
    fill: "url(#paint27_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M125.741 40.9728L125.913 41.3584C128.132 40.1844 129.28 38.1706 129.135 35.1456L128.775 34.7856C128.826 35.0856 128.852 35.3684 128.878 35.6512C129.023 37.9563 128.183 39.6702 126.238 40.7328C126.075 40.81 125.913 40.8871 125.741 40.9728Z",
    fill: "url(#paint28_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M125.913 41.3498L126.179 41.9411C128.613 40.5957 129.589 38.4533 129.795 35.8054L129.127 35.137C129.272 38.1705 128.133 40.1758 125.913 41.3498Z",
    fill: "url(#paint29_radial_59_1663)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M118.346 0.233622L128.647 34.657L127.618 33.6287L117.789 0.482143L118.269 0.0708008L118.346 0.233622Z",
    fill: "url(#paint30_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M128.047 34.0572L128.064 34.0743C128.064 34.0572 128.064 34.0401 128.064 34.0315L128.047 34.0572Z",
    fill: "url(#paint31_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M124.585 39.8243L124.756 40.21C126.976 39.036 128.124 37.0221 127.978 33.9971L127.619 33.6372C127.67 33.9371 127.696 34.2199 127.721 34.5027C127.867 36.8079 127.027 38.5218 125.082 39.5844C124.928 39.6615 124.756 39.7386 124.585 39.8243Z",
    fill: "url(#paint32_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M124.756 40.2014L125.022 40.7927C127.524 39.353 128.604 37.2363 128.638 34.6569L127.969 33.9885C128.124 37.0221 126.975 39.0274 124.756 40.2014Z",
    fill: "url(#paint33_radial_59_1663)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M117.575 0.473599L127.489 33.5088L126.47 32.4804L117.018 0.72212L117.497 0.310791L117.575 0.473599Z",
    fill: "url(#paint34_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M126.89 32.9088L126.907 32.9259C126.907 32.9088 126.907 32.8916 126.907 32.8831L126.89 32.9088Z",
    fill: "url(#paint35_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M123.521 38.8818L123.693 39.2674C125.912 38.0934 126.966 35.8739 126.821 32.8489L126.461 32.489C126.512 32.7889 126.538 33.0717 126.564 33.3545C126.709 35.6597 125.964 37.5878 124.019 38.6419C123.864 38.7276 123.693 38.8047 123.521 38.8818Z",
    fill: "url(#paint36_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M123.693 39.2674L123.959 39.8587C126.693 38.6247 127.353 35.6682 127.49 33.5173L126.821 32.8489C126.967 35.8739 125.913 38.0934 123.693 39.2674Z",
    fill: "url(#paint37_radial_59_1663)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M33.9628 28.4787C33.74 28.6073 33.6457 28.8815 33.7486 29.1129L57.6401 70.9403C57.7601 71.1974 58.0772 71.3002 58.3343 71.1631L58.3686 71.1459C58.5914 71.0174 58.6856 70.7432 58.5828 70.5118L34.6569 28.7101C34.537 28.4359 34.2199 28.3331 33.9628 28.4787Z",
    fill: "url(#paint38_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M42.8407 24.5538C42.6179 24.6824 42.5237 24.9566 42.6265 25.1794L65.8325 66.7326C65.9525 66.9897 66.2696 67.0925 66.5181 66.9468L66.5524 66.9297C66.7752 66.8012 66.8695 66.5269 66.7666 66.3041L43.5263 24.7681C43.4149 24.5196 43.0978 24.4167 42.8407 24.5538Z",
    fill: "url(#paint39_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M102.501 8.48621C102.261 8.5719 102.107 8.78614 102.15 8.97467L114.918 43.4409C114.97 43.6552 115.244 43.7494 115.518 43.6552L115.561 43.638C115.801 43.5523 115.955 43.3381 115.912 43.1496L103.109 8.70044C103.049 8.48621 102.775 8.39194 102.501 8.48621Z",
    fill: "url(#paint40_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M111.011 5.60672C110.771 5.69242 110.617 5.90666 110.659 6.09519L123.282 40.1501C123.334 40.3558 123.608 40.4586 123.882 40.3558L123.925 40.3386C124.165 40.253 124.319 40.0387 124.276 39.8502L111.619 5.8124C111.568 5.60673 111.285 5.51246 111.011 5.60672Z",
    fill: "url(#paint41_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M52.3017 21.5288C52.0789 21.6573 51.9846 21.923 52.0874 22.1544L73.8624 63.202C73.9738 63.4591 74.2909 63.5533 74.548 63.4162L74.5822 63.3991C74.805 63.2705 74.8993 63.0049 74.7964 62.7735L52.9872 21.743C52.8673 21.486 52.5502 21.3831 52.3017 21.5288Z",
    fill: "url(#paint42_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M93.2462 10.4399C93.0062 10.5341 92.852 10.7484 92.9034 10.9283L106.1 47.734C106.152 47.9397 106.435 48.034 106.7 47.9311L106.735 47.914C106.974 47.8197 107.129 47.6055 107.077 47.4255L93.8461 10.637C93.7946 10.4227 93.5118 10.337 93.2462 10.4399Z",
    fill: "url(#paint43_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M62.1905 18.0668C61.9677 18.1953 61.8649 18.461 61.9678 18.6838L82.5773 59.0887C82.6887 59.3372 82.9972 59.4314 83.2542 59.2858L83.2885 59.2686C83.5113 59.1401 83.6141 58.8744 83.5113 58.6516L62.8676 18.2724C62.7562 18.0239 62.4476 17.9297 62.1905 18.0668Z",
    fill: "url(#paint44_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M72.9113 15.076C72.6885 15.2046 72.5856 15.4702 72.6885 15.693L90.77 55.0782C90.8814 55.3267 91.1899 55.4124 91.447 55.2753L91.4812 55.2581C91.704 55.1296 91.8069 54.8639 91.704 54.6411L73.5797 15.2731C73.4769 15.0246 73.1598 14.9304 72.9113 15.076Z",
    fill: "url(#paint45_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M82.372 12.1111C82.1406 12.2311 82.0292 12.4796 82.1063 12.6852L98.2597 51.5733C98.354 51.8047 98.6539 51.8904 98.911 51.7619L98.9453 51.7447C99.1767 51.6248 99.2881 51.3762 99.2109 51.1706L83.0147 12.3082C82.929 12.0682 82.6291 11.9825 82.372 12.1111Z",
    fill: "url(#paint46_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M1.72474 22.24L0.0537109 29.7211L22.9855 35.2141C24.528 35.5826 26.0962 34.7342 26.6361 33.2517L27.1503 31.8463C27.7844 30.0982 26.7561 28.1872 24.9479 27.7587L1.72474 22.24ZM5.39245 29.2327C4.24415 29.7297 2.89876 29.1984 2.40173 28.0415C1.9047 26.8932 2.43602 25.5478 3.59289 25.0508C4.74977 24.5537 6.09517 25.085 6.59219 26.2334C7.08065 27.3902 6.54933 28.7356 5.39245 29.2327Z",
    fill: "url(#paint47_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M58.0088 75.3708L126.89 42.1213L127.327 43.0897L58.4287 76.3562L58.0088 75.3708Z",
    fill: "url(#paint48_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M57.4346 73.9394L126.324 40.6814L126.761 41.6583L57.863 74.9163L57.4346 73.9394Z",
    fill: "url(#paint49_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M124.585 39.8247L57.8633 72.1229L58.2918 73.0998L125.022 40.793L124.585 39.8247Z",
    fill: "url(#paint50_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M123.651 38.7019L57.4521 70.6488L57.8721 71.6257L124.191 39.756L123.651 38.7019Z",
    fill: "url(#paint51_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M32.1637 29.0871C31.9409 29.2157 31.8466 29.4899 31.958 29.7298L58.4205 76.5618C58.5404 76.8275 58.8575 76.9303 59.1146 76.7932L59.1489 76.776C59.3717 76.6475 59.4659 76.3733 59.3545 76.1333L32.8579 29.3185C32.7379 29.0443 32.4208 28.9415 32.1637 29.0871Z",
    fill: "url(#paint52_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M42.3102 26.1048C42.0874 26.2333 41.9931 26.5075 42.1045 26.7475L67.8471 72.4054C67.9671 72.6711 68.2842 72.7739 68.5413 72.6368L68.5755 72.6197C68.7983 72.4911 68.8926 72.2169 68.7812 71.9769L43.0043 26.3361C42.8843 26.0705 42.5673 25.9591 42.3102 26.1048Z",
    fill: "url(#paint53_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M103.77 8.26324C103.53 8.34894 103.375 8.56318 103.418 8.76027L117.618 47.1942C117.669 47.4084 117.952 47.5112 118.218 47.4084L118.261 47.3913C118.5 47.3056 118.655 47.0914 118.612 46.8943L104.378 8.4689C104.327 8.26324 104.044 8.16041 103.77 8.26324Z",
    fill: "url(#paint54_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M112.708 4.60413C112.468 4.68982 112.314 4.90405 112.357 5.09258L126.453 43.2437C126.505 43.4579 126.788 43.5522 127.053 43.4579L127.088 43.4408C127.328 43.3551 127.482 43.1409 127.439 42.9524L113.308 4.81836C113.257 4.60413 112.974 4.50986 112.708 4.60413Z",
    fill: "url(#paint55_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M51.8476 22.9855C51.6248 23.114 51.5305 23.3883 51.6333 23.6196L75.7563 68.1379C75.8763 68.3949 76.1933 68.4978 76.4418 68.3607L76.4762 68.3435C76.699 68.215 76.7932 67.9408 76.6904 67.7094L52.5331 23.2083C52.4217 22.9512 52.1047 22.8484 51.8476 22.9855Z",
    fill: "url(#paint56_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M94.3094 10.3284C94.0694 10.4227 93.9237 10.6455 93.9751 10.8512L108.603 51.4446C108.663 51.676 108.946 51.7788 109.22 51.676L109.254 51.6588C109.494 51.5646 109.64 51.3418 109.589 51.1361L94.9263 10.5598C94.8664 10.3284 94.5836 10.2256 94.3094 10.3284Z",
    fill: "url(#paint57_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M62.1054 19.7377C61.8826 19.8662 61.7883 20.1319 61.8912 20.3632L84.4116 64.0245C84.523 64.2816 84.8401 64.3759 85.0972 64.2302L85.1315 64.213C85.3543 64.0845 85.4485 63.8188 85.3457 63.5875L62.7909 19.9433C62.671 19.6948 62.3539 19.6006 62.1054 19.7377Z",
    fill: "url(#paint58_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M72.9882 16.4728C72.7654 16.6013 72.6711 16.867 72.774 17.0983L92.6036 59.9798C92.715 60.2369 93.0321 60.3311 93.2892 60.1855L93.3235 60.1683C93.5463 60.0398 93.6405 59.7741 93.5377 59.5427L73.6737 16.687C73.5538 16.4299 73.2367 16.3357 72.9882 16.4728Z",
    fill: "url(#paint59_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M83.7171 13.602C83.4857 13.722 83.3829 13.9876 83.4772 14.219L101.019 55.5837C101.122 55.8408 101.43 55.9522 101.696 55.8236L101.73 55.8065C101.961 55.6865 102.064 55.4208 101.97 55.1895L84.3941 13.8419C84.2827 13.5763 83.9742 13.4735 83.7171 13.602Z",
    fill: "url(#paint60_linear_59_1663)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M25.5137 32.4206L115.441 5.66683L115.381 3.67871L26.3535 30.1411L25.5137 32.4206Z",
    fill: "url(#paint61_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M32.8316 46.2687C32.9344 46.5086 33.2001 46.6286 33.4486 46.5429L125.099 15.4616C125.373 15.3673 125.51 15.0588 125.399 14.7931L125.381 14.7589C125.279 14.5189 125.013 14.3989 124.765 14.4846L33.1315 45.6003C32.8488 45.6945 32.7116 46.003 32.8316 46.2687Z",
    fill: "url(#paint62_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M40.7498 59.5941C40.8526 59.834 41.1182 59.954 41.3668 59.8683L128.818 25.8134C129.092 25.7191 129.229 25.4106 129.118 25.1449L129.101 25.1107C128.998 24.8707 128.732 24.7508 128.484 24.8364L41.0497 58.9342C40.7755 59.0285 40.6383 59.3284 40.7498 59.5941Z",
    fill: "url(#paint63_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M48.9937 72.6711C49.0966 72.9111 49.3622 73.0311 49.6107 72.9454L131.5 36.1054C131.774 36.0111 131.912 35.7026 131.8 35.4369L131.783 35.4027C131.68 35.1627 131.415 35.0427 131.166 35.1284L49.2937 72.0113C49.0109 72.097 48.8737 72.4055 48.9937 72.6711Z",
    fill: "url(#paint64_linear_59_1663)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M111.002 2.4361L111.945 6.71224L124.139 3.70437C124.139 3.70437 123.402 -0.477516 118.937 0.0452193L111.002 2.4361Z",
    fill: "url(#paint65_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M57.7087 75.4134C57.4345 78.4898 55.5149 100.539 57.4259 104.824L57.006 105.158C54.6409 101.61 57.1431 75.0535 57.1431 75.0535L57.7087 75.4134Z",
    fill: "url(#paint66_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M58.8489 76.1417C57.8634 86.605 57.4349 95.4572 58.4033 103.127L57.4263 104.824C55.5239 100.539 57.4349 78.4898 57.7092 75.4133L58.8489 76.1417Z",
    fill: "url(#paint67_radial_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M58.8489 76.1417C57.8634 86.605 57.4349 95.4572 58.4033 103.127L57.4263 104.824C55.5239 100.539 57.4349 78.4898 57.7092 75.4133L58.8489 76.1417Z",
    fill: "url(#paint68_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M58.4029 103.127L127.267 75.4648L126.007 79.3468L57.5202 106.332L57.0146 105.158L58.4029 103.127Z",
    fill: "url(#paint69_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M125.607 97.4873C129.834 96.1458 132.174 91.6316 130.832 87.4045C129.491 83.1775 124.977 80.8382 120.749 82.1797C116.522 83.5212 114.183 88.0354 115.525 92.2624C116.866 96.4895 121.38 98.8287 125.607 97.4873Z",
    fill: "#4A5050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M129.195 87.2222C130.635 90.5557 129.101 94.429 125.767 95.8687C122.434 97.3084 118.56 95.7744 117.121 92.4409C115.681 89.1074 117.215 85.234 120.549 83.7944C123.882 82.3461 127.755 83.8886 129.195 87.2222Z",
    fill: "#38393B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M125.57 88.7903C126.144 90.1271 125.535 91.6696 124.199 92.2523C122.862 92.8265 121.319 92.218 120.737 90.8812C120.162 89.5444 120.771 88.0019 122.108 87.4192C123.445 86.8364 124.996 87.4535 125.57 88.7903Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M115.646 83.3574L120.66 91.1556C121.414 92.321 122.905 92.7752 124.173 92.2267C124.696 92.0039 125.124 91.6354 125.424 91.1813C125.724 90.7271 125.896 90.1786 125.896 89.6131V78.9355L115.646 83.3574ZM124.062 91.4641C123.076 91.8925 121.936 91.4383 121.508 90.4529C121.08 89.4674 121.534 88.3276 122.519 87.8992C123.505 87.4707 124.644 87.9249 125.073 88.9104C125.501 89.8959 125.047 91.0442 124.062 91.4641Z",
    fill: "url(#paint70_linear_59_1663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M84.1111 104.438C85.8678 108.509 83.9911 113.239 79.9206 114.996C75.8502 116.752 71.1198 114.876 69.3631 110.805C67.6063 106.735 69.4831 102.004 73.5535 100.248C77.624 98.491 82.3544 100.368 84.1111 104.438Z",
    fill: "#4A5050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M83.1872 108.95C83.9062 105.387 81.6008 101.916 78.038 101.197C74.4752 100.478 71.0042 102.784 70.2852 106.346C69.5662 109.909 71.8716 113.38 75.4344 114.099C78.9972 114.818 82.4683 112.513 83.1872 108.95Z",
    fill: "#38393B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M79.1498 106.58C79.724 107.917 79.1155 109.46 77.7787 110.043C76.4419 110.617 74.8994 110.008 74.3167 108.671C73.7425 107.335 74.3509 105.792 75.6877 105.209C77.0331 104.635 78.5757 105.252 79.1498 106.58Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M69.2344 101.156L74.2475 108.954C75.0016 110.12 76.4927 110.574 77.761 110.025C78.2837 109.803 78.7121 109.434 79.0121 108.98C79.312 108.526 79.4834 107.977 79.4834 107.412V96.7343L69.2344 101.156ZM77.6496 109.263C76.6641 109.691 75.5243 109.237 75.0958 108.252C74.6674 107.266 75.1215 106.126 76.107 105.698C77.0925 105.269 78.2323 105.724 78.6608 106.709C79.0892 107.695 78.6351 108.834 77.6496 109.263Z",
    fill: "url(#paint71_linear_59_1663)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_1663",
    x1: 9.95209,
    y1: 26.8921,
    x2: 39.3742,
    y2: 30.7769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864AF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_1663",
    x1: 70.1058,
    y1: 14.1758,
    x2: 70.7227,
    y2: 16.2446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5673,
    stopColor: "#CCCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6835,
    stopColor: "#A1A09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8435,
    stopColor: "#5E5D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_1663",
    x1: 78.5225,
    y1: 27.6032,
    x2: 78.8562,
    y2: 28.5844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5673,
    stopColor: "#CCCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6835,
    stopColor: "#A1A09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8435,
    stopColor: "#5E5D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_1663",
    x1: 83.3778,
    y1: 37.0303,
    x2: 84.7111,
    y2: 40.4365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7162,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7283,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7667,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7876,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8107,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9228,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9837,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_1663",
    x1: 89.0981,
    y1: 49.6942,
    x2: 90.2569,
    y2: 52.2418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6109,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6332,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6678,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7042,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7858,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9228,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9837,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.3384 75.9831) rotate(-74.514) scale(0.051418 0.139832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4459,
    stopColor: "#9D9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8019,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_59_1663",
    x1: 38.1716,
    y1: 53.7486,
    x2: 39.017,
    y2: 53.2338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3467,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3865,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4391,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6393,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7622,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8671,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9497,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4228 74.053) rotate(-74.5086) scale(0.0231343 0.0629341)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4459,
    stopColor: "#9D9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8019,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.0214 73.4146) rotate(-71.0649) scale(2.58158 5.00193)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5653,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6195,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7022,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7243,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9143,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5836 74.8914) rotate(-64.2728) scale(2.70991 6.63013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0503,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1329,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3607,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5609,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6376,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6533,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_59_1663",
    x1: 38.5148,
    y1: 52.6242,
    x2: 39.2849,
    y2: 52.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3467,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3865,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4391,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6393,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7622,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8671,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9497,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3519 72.4276) rotate(-74.5199) scale(0.0230474 0.0626565)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4459,
    stopColor: "#9D9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8019,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9506 71.7887) rotate(-71.065) scale(2.58157 5.00191)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5653,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6195,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7022,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7243,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9143,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5119 73.2658) rotate(-64.2728) scale(2.70991 6.63013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0503,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1329,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3607,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5609,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6376,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6533,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_59_1663",
    x1: 38.6083,
    y1: 51.2696,
    x2: 39.3783,
    y2: 50.8007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3467,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3865,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4391,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6393,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7622,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8671,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9497,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.2802 70.8021) rotate(-74.5142) scale(0.0230568 0.0627027)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4459,
    stopColor: "#9D9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8019,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.8787 70.1633) rotate(-71.065) scale(2.58159 5.00193)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5653,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6195,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7022,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7243,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9143,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4401 71.6403) rotate(-64.2728) scale(2.70991 6.63014)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0503,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1329,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3607,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5609,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6376,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6533,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_59_1663",
    x1: 38.9128,
    y1: 50.2602,
    x2: 39.6829,
    y2: 49.7913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3467,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3865,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4391,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6393,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7622,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8671,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9497,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.2091 69.1765) rotate(-74.5086) scale(0.0230486 0.062701)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4459,
    stopColor: "#9D9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8019,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.8079 68.5378) rotate(-71.0649) scale(2.58158 5.00193)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5653,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6195,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7022,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7243,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9143,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.3705 70.0146) rotate(-64.2728) scale(2.70991 6.63013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0503,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1329,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3607,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5609,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6376,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6533,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_59_1663",
    x1: 125.892,
    y1: 18.6226,
    x2: 124.941,
    y2: 18.9005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3467,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3865,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4391,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6393,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7622,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8671,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9497,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.352 36.354) rotate(-153.062) scale(0.0230999 0.0628856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4459,
    stopColor: "#9D9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8019,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.448 38.5967) rotate(-156.555) scale(2.58164 5.00197)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5653,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6195,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7022,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7243,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9143,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.854 39.22) rotate(-163.341) scale(2.70996 6.63009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0503,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1329,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3607,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5609,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6376,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6533,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_59_1663",
    x1: 124.969,
    y1: 18.078,
    x2: 123.847,
    y2: 18.4057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3467,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3865,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4391,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6393,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7622,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8671,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9497,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.2 35.2057) rotate(-153.126) scale(0.0230717 0.0627071)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4459,
    stopColor: "#9D9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8019,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.295 37.4487) rotate(-156.554) scale(2.5816 5.00196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5653,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6195,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7022,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7243,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9143,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.702 38.072) rotate(-163.341) scale(2.70996 6.63008)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0503,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1329,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3607,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5609,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6376,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6533,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_59_1663",
    x1: 123.883,
    y1: 17.2406,
    x2: 122.837,
    y2: 17.5461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3467,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3865,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4391,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6393,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7622,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8671,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9497,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.047 34.0575) rotate(-153.055) scale(0.0231013 0.0629009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4459,
    stopColor: "#9D9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8019,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.142 36.3004) rotate(-156.555) scale(2.58164 5.00197)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5653,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6195,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7022,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7243,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9143,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.549 36.9237) rotate(-163.341) scale(2.70996 6.63009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0503,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1329,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3607,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5609,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6376,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6533,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_59_1663",
    x1: 122.941,
    y1: 16.7827,
    x2: 121.866,
    y2: 17.0966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3467,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3865,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4391,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6393,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7622,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8671,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9497,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.893 32.9093) rotate(-153.126) scale(0.0231575 0.0629402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4459,
    stopColor: "#9D9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8019,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.014 35.2149) rotate(-156.555) scale(2.6742 5.18131)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5653,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6195,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7022,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7243,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9143,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.433 35.8637) rotate(-163.341) scale(2.77156 6.78084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0503,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1329,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3607,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5609,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6376,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6533,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_59_1663",
    x1: 47.4444,
    y1: 49.0955,
    x2: 45.5532,
    y2: 50.1467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_59_1663",
    x1: 55.604,
    y1: 45.2448,
    x2: 54.2682,
    y2: 45.9873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_59_1663",
    x1: 110.246,
    y1: 25.6291,
    x2: 108.448,
    y2: 26.2743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_59_1663",
    x1: 118.684,
    y1: 22.5388,
    x2: 116.888,
    y2: 23.1834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_59_1663",
    x1: 64.9498,
    y1: 41.6188,
    x2: 62.6877,
    y2: 42.8759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_59_1663",
    x1: 101.352,
    y1: 28.6615,
    x2: 99.3124,
    y2: 29.4288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_59_1663",
    x1: 75.0548,
    y1: 37.4619,
    x2: 71.5977,
    y2: 39.2493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_59_1663",
    x1: 87.725,
    y1: 32.6431,
    x2: 80.8448,
    y2: 35.6839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_59_1663",
    x1: 94.8096,
    y1: 30.2047,
    x2: 88.7389,
    y2: 32.5466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_59_1663",
    x1: 25.8087,
    y1: 31.2626,
    x2: 2.26903,
    y2: 26.8386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864AF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_59_1663",
    x1: 92.4057,
    y1: 58.7014,
    x2: 92.9306,
    y2: 59.7989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2706,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3077,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4255,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4899,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5608,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_59_1663",
    x1: 91.836,
    y1: 57.2664,
    x2: 92.3609,
    y2: 58.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2706,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3077,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4255,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4899,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5608,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_59_1663",
    x1: 91.1671,
    y1: 55.9042,
    x2: 91.7234,
    y2: 57.0518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2706,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3077,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4255,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4899,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5608,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_59_1663",
    x1: 90.4765,
    y1: 54.5455,
    x2: 91.14,
    y2: 55.9144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2706,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3077,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4255,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4899,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5608,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_59_1663",
    x1: 46.7916,
    y1: 52.2942,
    x2: 45.1152,
    y2: 53.2259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_59_1663",
    x1: 56.5313,
    y1: 48.752,
    x2: 54.9243,
    y2: 49.6452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_59_1663",
    x1: 112.239,
    y1: 27.3888,
    x2: 110.436,
    y2: 28.0359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_59_1663",
    x1: 121.12,
    y1: 23.5874,
    x2: 119.315,
    y2: 24.2351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_59_1663",
    x1: 65.3831,
    y1: 44.9851,
    x2: 63.5587,
    y2: 45.9991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_59_1663",
    x1: 103.147,
    y1: 30.4802,
    x2: 101.107,
    y2: 31.2482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_59_1663",
    x1: 75.0297,
    y1: 41.2738,
    x2: 72.9163,
    y2: 42.3164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_59_1663",
    x1: 85.1341,
    y1: 37.4134,
    x2: 82.1449,
    y2: 38.7569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_59_1663",
    x1: 95.1967,
    y1: 33.6896,
    x2: 91.4631,
    y2: 35.1893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_59_1663",
    x1: 70.0585,
    y1: 16.7363,
    x2: 70.6755,
    y2: 18.8055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5673,
    stopColor: "#CCCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6835,
    stopColor: "#A1A09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8435,
    stopColor: "#5E5D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_59_1663",
    x1: 78.9376,
    y1: 30.0262,
    x2: 79.2712,
    y2: 31.0073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5673,
    stopColor: "#CCCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6835,
    stopColor: "#A1A09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8435,
    stopColor: "#5E5D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_59_1663",
    x1: 83.7928,
    y1: 39.453,
    x2: 85.1261,
    y2: 42.8592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7162,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7283,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7667,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7876,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8107,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9228,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9837,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_59_1663",
    x1: 89.5131,
    y1: 52.1169,
    x2: 90.6719,
    y2: 54.6646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6109,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6332,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6678,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7042,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7858,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9228,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9837,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_59_1663",
    x1: 127.057,
    y1: -2.20729,
    x2: 112.383,
    y2: 5.94819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864AF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_59_1663",
    x1: 43.4252,
    y1: 86.322,
    x2: 66.7788,
    y2: 92.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5653,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6195,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7022,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7243,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9143,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_59_1663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.3494 117.09) rotate(60.764) scale(8.46937 27.4648)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1087,
    stopColor: "#7F7E7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3145,
    stopColor: "#A4A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5772,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    stopColor: "#DAD9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6863,
    stopColor: "#D2D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7171,
    stopColor: "#C4C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#B1B0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7677,
    stopColor: "#979694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7898,
    stopColor: "#787775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8105,
    stopColor: "#535250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8295,
    stopColor: "#2A2927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8378,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_59_1663",
    x1: 56.6453,
    y1: 90.1174,
    x2: 59.6245,
    y2: 90.1292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2325,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3645,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4871,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5917,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6742,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7243,
    stopColor: "#151412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9143,
    stopColor: "#71706E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_59_1663",
    x1: 91.851,
    y1: 89.6,
    x2: 93.0478,
    y2: 92.5704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2706,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3077,
    stopColor: "#898886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#A7A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4255,
    stopColor: "#BEBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4899,
    stopColor: "#CFCECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5608,
    stopColor: "#D9D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#DCDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#989795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7784,
    stopColor: "#5F5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8308,
    stopColor: "#373634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8722,
    stopColor: "#1E1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8973,
    stopColor: "#151412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_59_1663",
    x1: 120.659,
    y1: 80.8656,
    x2: 125.021,
    y2: 91.6913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864AF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_59_1663",
    x1: 74.244,
    y1: 98.661,
    x2: 78.6057,
    y2: 109.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864AF6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group_2.a663942b4549a2ec1197313aa2aa7ae0.svg";
export { ForwardRef as ReactComponent };